<script setup lang="ts">
import { onUpdated, ref } from 'vue';
import type { OpenerProps } from './popup';

const props = withDefaults(defineProps<OpenerProps>(), {
	pos: '3',
	notch: true,
	posBy: 'fixed',
});

const id = props.id || Math.random() + '';

let elOpener: Element;

/**
 * Необычная функция для проброски props внтурь элемента слота
 *
 * @param el - вспомогательрный элемент для доступа к элементам слота
 */
function render (el: any) {
	setTimeout(() => {
		elOpener = el.nextElementSibling;

		if (elOpener) {
			renderOpener(elOpener);
		}
	});
}

onUpdated(() => {
	if (elOpener) {
		renderOpener(elOpener);
	}
});

function renderOpener (elOpener: any) {
	elOpener.dataset.topPopup = 'vue-' + id;
	elOpener.dataset.topPopupId = id;
	elOpener.dataset.topPopupP = props.pos;
	elOpener.dataset.topPopupPosBy = props.posBy;
	elOpener.dataset.topPopupNotch = props.notch ? 'true' : '';
	elOpener.dataset.topPopupOpenByHover = props.openByHover ? 'true' : '';
}
</script>

<template>
	<template :ref="render"></template>

	<!-- @slot элемент для открытия Popup -->
	<slot></slot>
</template>

<style>
h3[data-top-popup],
div[data-top-popup],
i[data-top-popup]:not(.btn):not(.g_btn),
b[data-top-popup]:not(.btn):not(.g_btn) {
	cursor: pointer;
	user-select: none;
	font-style: normal;
	text-decoration: none;
	display: inline-flex;
	align-items: center;
}

[data-top-popup][data-top-popup-disabled] {
	pointer-events: none;
	cursor: auto !important;
}

i[contenteditable] {
	cursor: text !important;
}
</style>